import { hyper } from "hyperhtml";
/**
 * @class Clock
 */
class NodeProperties extends hyper.Component {
  /**
   * @function defaultState
   * @return {type} {description}
   */
  get defaultState() {
    return {
      date: new Date()
    };
  }
  /**
   * @function constructor
   * @param  {type} node {description}
   */
  constructor(node) {
    super();
    this.node = node;
    this.name = this.constructor.name;
  }
  /**
   * destroy the component
   * @function destroy
   */
  destroy() {
    $("tephra_manager").removeClass("open");
    setTimeout(() => {
      $("tephra_manager").remove();
    }, 1000);
  }
  /**
   * @function genDataGrid
   * @return {HyperHTML}
   */
  genDataGrid() {
    const data = this.node.data;
    let genLiteral = data => {
      let literal = ``;
      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          let element = data[key];
          if (element instanceof Array) {
            element.map(item => {
              if (item instanceof Object) {
                literal += `
                              <div class="properties_group_label">${key}:: ${item.name || item.title}:</div>
                              <div class="properties_group grid col-100-fr">${genLiteral(item)}</div>`;
              } else {
                literal += JSON.stringify(item);
              }
              return item;
            });
          } else {
            let dateElement = new Date(element);
            element =
              dateElement !== "Invalid Date" && !isNaN(dateElement) && String(element).match(/\d\d:00/)
                ? dateElement
                : element;
            literal += `<div class="property_key">${key}:</div>
                        <div class="property_value">${String(element).encodeHtmlEntity()}</div>
                        `;
          }
        }
      }
      return literal;
    };
    return genLiteral(data);
  }

  /**
   * add tags to tephra snippet
   * @function addTags
   * @param {object} event form event
   */
  addTags() {}
  /**
   * @function render
   * @return {html} returns the component template.
   */
  render() {
    return this.html`<h3>${this.node.title} </h3>
<div class="grid properties_grid col-100-fr">
    ${{
      html: this.genDataGrid(),
      placeholder: "loading properties..."
    }}
</div>`;
  }
}
export default new NodeProperties();
